


<div #details >
  <br>
  <br>
  <div id="swagger-ui">

  </div>
 
  
</div>